import { render } from "./AddEditGimItemType.vue?vue&type=template&id=1ba3f758"
import script from "./AddEditGimItemType.vue?vue&type=script&lang=js"
export * from "./AddEditGimItemType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__